import {
  CreateEsignatureRequestsDocument,
  CreateEsignatureRequestsMutationVariables,
  DocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateEsignatureRequests = () => {
  const [createEsignatureRequest, { loading }] = useMutation(CreateEsignatureRequestsDocument, {
    extractorFn: (data) => data.esignatureMutations.bulkCreateEsignatureRequest,
  })

  return {
    loading,
    create(variables: CreateEsignatureRequestsMutationVariables) {
      return createEsignatureRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [DocumentsDocument],
      })
    },
  }
}
